import React, { useEffect, useRef, useState } from "react";
import Pagelayout from "../../../components/Pagelayout";
import { useLocation, useNavigate } from "react-router-dom";
import {
  variableAndRecurringAPI,
  variableAndRequiringAPI,
} from "../../../parollAPIs";
import { ACTION_TYPE, VIEW_TYPE } from "../../../payrollEnums";
import VariableAndRecurringLayout from "../../layout/VariableAndRecurringLayout";

const CreateRecurringAllowance = () => {
  const location = useLocation();
  const singleViewId = location?.state?._id || null;

  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const navigate = useNavigate();
  const formRef = useRef();

  const handleSave = async () => {
    if (formRef.current) {
      const validatedData = formRef.current.getValidatedFormData();
      if (validatedData) {
        // console.log("Validated Data:", validatedData);
        const navigateTo = () => {
          navigate(
            "/userdashboard/payroll/variableAndRecurring/allowance/recurring/"
          );
        };
        variableAndRequiringAPI({
          body: {
            payHeadId: validatedData?.payHeadAllowance?._id,
            empId: validatedData?.employee?._id,
            date: validatedData?.from,
            dateTo: validatedData?.to,
            isRecurring: true,
            amount: validatedData?.amount,
            isAllowance: true,
            count: validatedData?.count,
            id: singleViewId,
          },
          setLoading,
          setSnackbar,
          actionType: singleViewId ? ACTION_TYPE.UPDATE : ACTION_TYPE.ADD,
          navigateTo,
          setIsEdit,
        });
      } else {
        console.error("Validation failed.");
      }
    }
  };

  //initial api call
  useEffect(() => {
    if (singleViewId) {
      setIsEdit(true);
      variableAndRecurringAPI({
        body: { _id: singleViewId },
        viewType: VIEW_TYPE.SINGLE,
        setLoading,
      });
    } else {
      setIsEdit(false);
    }
  }, [singleViewId]);

  const handleEdit = () => {
    setIsEdit(!isEdit);
  };

  return (
    <Pagelayout
      pageName="Create Contract Payslip"
      headerLayout={2}
      handleBack={() =>
        navigate(
          "/userdashboard/payroll/variableAndRecurring/allowance/recurring/"
        )
      }
      handleSave={handleSave}
      newData={!isEdit}
      isLoading={loading}
      snackbar={snackbar}
      setSnackbar={setSnackbar}
      handleEdit={handleEdit}
      status={singleViewId?"done":"new"}
    >
      <VariableAndRecurringLayout
        ref={formRef}
        category="Allowance"
        section="Recurring"
        loading={loading}
        singleViewId={singleViewId}
        isEdit={isEdit}
      />
    </Pagelayout>
  );
};

export default CreateRecurringAllowance;
